.heading {
  margin-top: var(--dds-spacing-small-16);
}

.wrapper {
  margin-top: var(--dds-spacing-medium-40);
  margin-bottom: var(--dds-spacing-small-16);

  fieldset {
    margin-bottom: var(--dds-spacing-medium-40);
  }
}
